// extracted by mini-css-extract-plugin
module.exports = {"container":"Ad-z","copy":"Bd-z","field":"Cd-z","error":"Dd-z","disabled":"Ed-z","termsContainer":"Fd-z","termsHeading":"Gd-z","termsCopy":"Hd-z","submit":"Id-z","srOnly":"Jd-z"};